<template>

  <div class="all">
    <headercon></headercon>
    <div class="anniu">
      <img :src="img1"
           alt=""
           @click="go"
           class="button">
      <div class="box">
        <div class="box3"
             id="allmap">
        </div>
      </div>
      <img :src="img2"
           alt=""
           @click="go1"
           class="button1">
    </div>
  </div>
</template>

<script>
import BMap from 'BMap'
import headercon from './header'
export default {
  components: {
    headercon
  },
  name: 'HelloWorld',
  data () {
    return {
      img: require('../assets/componylogo.png'),
      img1: require('../assets/buttonl.png'),
      img2: require('../assets/buttonr.png'),
      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们'
    }
  },
  methods: {
    getMapData: function () {
      var map = new BMap.Map('allmap') // 创建Map实例
      var point = new BMap.Point(114.40469, 30.47178)
      map.centerAndZoom(point, 16)
      map.setCurrentCity('武汉') // 地图显示的城市
      map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
      window.map = map// 将map变量储存在全局
      var marker = new BMap.Marker(point)
      map.enableScrollWheelZoom(true) // 启用滚轮放大缩小，默认禁用
      map.enableKeyboard(true) // 启用键盘操作，默认禁用。
      map.enableDragging() // 启用地图拖拽，默认启用
      map.enableDoubleClickZoom() // 启用双击放大，默认启用
      map.addControl(new BMap.NavigationControl()) // 平移缩放控件
      map.addControl(new BMap.ScaleControl())
      //* ***将map变量存储在全局，只有将地图储存在全局，别的方法才能取到
      map.addOverlay(marker)
    },
    go () {
      this.$router.push({ path: '/aboutus' })
    },
    go1 () {
      this.$router.push({ path: '/recruit' })
    }
  },

  mounted () {
    this.getMapData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.all {
  background: url("../assets/map.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  /deep/ .li5 {
    list-style-type: none;
    float: left;
    border-radius: 25px;
    background: #fff;
    width: 100px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    line-height: 30px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
  .anniu {
    display: flex;
    width: 100%;
    min-width: 1000px;
    height: 70%;
    .button {
      margin-top: 19.5%;
      margin-left: 3%;
      width: 2%;
      height: 20%;
      text-align: center;
      line-height: 28px;
      background: linear-gradient(to right, #d5edfb, #eeffff);
      border: none;
      font-size: 80px;
      color: #62c3d0;
      -webkit-appearance: none;
    }
  }
}
@media only screen and (min-width: 1781px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
    -webkit-appearance: none;
  }
  .box {
    position: absolute;
    top: 25%;
    left: 10%;
    width: 90%;
    height: 55%;
    // min-width: 1000px;
    .box3 {
      display: block;
      width: 87%;
      height: 76%;
      margin-top: 6.5%;
      margin-left: 2.5%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1780px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
    -webkit-appearance: none;
  }
  .box {
    position: absolute;
    top: 25%;
    left: 10%;
    width: 90%;
    height: 55%;
    // min-width: 1000px;
    .box3 {
      display: block;
      width: 87%;
      height: 76%;
      margin-top: 6.5%;
      margin-left: 2.5%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media only screen and (min-width: 1421px) and (max-width: 1600px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
    -webkit-appearance: none;
  }
  .box {
    position: absolute;
    top: 25%;
    left: 10%;
    width: 90%;
    height: 55%;
    // min-width: 1000px;
    .box3 {
      display: block;
      width: 87%;
      height: 76%;
      margin-top: 6.5%;
      margin-left: 2.5%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1420px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
    -webkit-appearance: none;
  }
  .box {
    position: absolute;
    top: 25%;
    left: 10%;
    width: 90%;
    height: 55%;
    // min-width: 1000px;
    .box3 {
      display: block;
      width: 87%;
      height: 76%;
      margin-top: 6.5%;
      margin-left: 2.5%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .button1 {
    position: absolute;
    left: 1100px;
    top: 300px;
    width: 24px;
    height: 73px;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
    -webkit-appearance: none;
  }
  .box {
    position: absolute;
    top: 25%;
    left: 100px;
    width: 1000px;
    height: 55%;
    .box3 {
      display: block;
      width: 950px;
      height: 76%;
      margin-top: 6.5%;
      margin-left: 2.5%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue